import React, { useContext } from "react";

// Internal components
import Nav from "components/Nav";
import Btn from "components/Btn";
import LanguagePicker from "components/LanguagePicker";
import Meta from "components/Meta";

// Contexts
import { DataContext } from "contexts/Data";
const Home = () => {
    const { data, language } = useContext(DataContext);
    return (
        <>
            <Meta
                title={data.seo.home.title || ""}
                description={data.seo.home.description || ""}
                image={data.seo.home.image || ""}
            />
            <LanguagePicker />
            <section className="intro">
                <div
                    className="intro-text"
                    style={{
                        backgroundImage: `url(${
                            process.env.PUBLIC_URL +
                            `/images/${language}_intro_text.jpg`
                        })`,
                    }}
                />
                <div className="intro-grid">
                    <Nav className="intro-nav" />
                </div>
                <Btn
                    className="btn--patch-vertical next-btn"
                    to={data.pages.bakgrunn.to[language]}
                >
                    {data.nextButton[language]}
                </Btn>
            </section>
        </>
    );
};

export default Home;
